interface Props {
  className?: string;
}

export default function FloorPlanIcon({className}: Props) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 19">
      <path
        fill="currentColor"
        d="M2 11v6h3v-2h1v2h10v-5H9.5v-1H16V7h-2V5h4v14H0V0h11v7H9V2H6v2H5V2H2v7h3V7h1v5H5v-2H2v1Z"
      />
    </svg>
  );
}
